// import { reactive, ref, set, computed } from '@vue/composition-api';
import { pagesModule } from '@/store/database/pagesModule';
import useMultiSelect from '@/views/Context/use/useMultiSelect';
import { updatePage } from '@/components/ContextDoc/use/useDocActions';

export default function useFlair() {
  const updateFlair = ({
    noteId,
    parentPageId,
    pageId,
    flair,
    value = undefined,
    enableState = false
  }) => {
    const { getSelectedNoteIds } = useMultiSelect();
    const selectedNoteIds = getSelectedNoteIds();
    let pagesToUpdate = [];
    if (selectedNoteIds.includes(noteId)) {
      const parentPage = pagesModule.doc(parentPageId).data;
      const selectedNotes = selectedNoteIds.map(n => parentPage.pageNotes[n]);
      selectedNotes.forEach(n => {
        pagesToUpdate.push(n.pageId);
      });
    } else {
      pagesToUpdate.push(pageId);
    }
    let setFlair = enableState;
    if (enableState == 'toggle' && selectedNoteIds.length > 1) {
      //  we need to set the enableState to force all updates to be the same, instead of toggling
      const thisPage = pagesModule.doc(pageId).data;
      if (thisPage.flair.enabled.includes(flair)) {
        // turn all off
        setFlair = 'disabled';
      } else {
        setFlair = 'enabled';
      }
    }

    pagesToUpdate.forEach(pageId => {
      //  first check if we want to enable, disable or toggle the state. If false, we do nothing
      if (enableState) {
        toggleFlair({
          pageId,
          flair,
          disabled: setFlair == 'disabled',
          enable: setFlair == 'enabled'
        });
      }

      //  now check if we are updating the value
      if (value != undefined) {
        console.log('update value', value);
        writeFlairUpdate({ pageId, key: flair, value });
      }
    });
  };

  const toggleFlair = ({ pageId, flair, enable = false, disable = false }) => {
    console.log('use flair toggle', pageId, flair);
    const page = pagesModule.doc(pageId).data;
    console.log(page);
    const enabledFlair = [...page.flair.enabled];
    const flairIndex = enabledFlair.indexOf(flair);

    if (flairIndex >= 0) {
      if (!enable) {
        enabledFlair.splice(flairIndex, 1);
      }
    } else {
      if (!disable) {
        enabledFlair.push(flair);
      }
    }
    writeFlairUpdate({
      pageId,
      key: 'enabled',
      value: enabledFlair
    });
  };

  const writeFlairUpdate = ({ pageId, key, value }) => {
    const update = { flair: {}};
    update['flair'][key] = value;
    updatePage({ pageId, update });
  };

  // const toggleSelectedNotesFlair = ({
  //   selectedNoteIds,
  //   parentPageId,
  //   flair,
  //   enableOnly,
  //   disableOnly
  // }) => {
  //   const { getPage } = usePages();
  //   const parentPage = getPage(parentPageId);
  //   const selectedNotes = selectedNoteIds.map(n => parentPage.value.pageNotes[n]);
  //   selectedNotes.forEach(n => {
  //     const page = getPage(n.pageId);
  //     toggleFlair({ pageId: page.id, flair, enableOnly, disableOnly });
  //   });
  // };

  // const updateSelectedNotesFlair = ({ selectedNoteIds, parentPageId, key, value }) => {
  //   const { getPage } = usePages();
  //   const parentPage = getPage(parentPageId);
  //   const selectedNotes = selectedNoteIds.map(n => parentPage.value.pageNotes[n]);
  //   selectedNotes.forEach(n => {
  //     const page = getPage(n.pageId);
  //     updateFlair({ pageId: page.id, key, value });
  //   });
  // };

  return {
    toggleFlair,
    updateFlair
    // updateSelectedNotesFlair,
    // toggleSelectedNotesFlair
  };
}
